import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export function PostHogProvider({ children }: Props) {
  return <PHProvider client={posthog}>{children}</PHProvider>
}
